module.exports = __webpack_public_path__ + "img/twitter-black.c019bd43.png";